const getters = {
  token: (state) => {
    if(state.user.token) {
      wps.PluginStorage.setItem("token", state.user.token);
    } else {
      wps.PluginStorage.setItem("token", '');
    }
    console.log('getter', state.user.token)
    wps.ribbonUI.Invalidate();
    return state.user.token;
  },
  user: (state) => state.user.data,
};

export default getters;
